import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=beccf66c&"
import script from "./Alert.vue?vue&type=script&lang=ts&"
export * from "./Alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VSheet})
